import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    ACTION_ACCRUALANZ_LOAD_BY_ID,
    ACTION_ACCRUALANZ_LOAD_BY_TRIAL_ID,
    ACTION_ACCRUALANZ_LOAD_FAILURE,
    ACTION_ACCRUALANZ_LOAD_SUCCESS,

    ACTION_ACCRUALANZ_CLEAR,

    AccrualANZAction
} from '../actions/accrualANZ';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState } from "./index";


export interface IAccrualANZState {
    data: Dtos.AccrualANZ | Dtos.AccrualANZ[],
    loadState: IRequestState;
}

const initialState: IAccrualANZState = {
    data: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
};


function loading(state: IAccrualANZState, _isLoading: boolean): IAccrualANZState {
    const newState: IAccrualANZState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(
    state: IAccrualANZState,
    data: Dtos.AccrualANZ | Dtos.AccrualANZ[],
    responseStatus: Dtos.ResponseStatus
): IAccrualANZState {
    const newState: IAccrualANZState = update(state, {
        data: {
            $set: data
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        }
    });

    return newState;
}

function loadFailure(state: IAccrualANZState, responseStatus: Dtos.ResponseStatus): IAccrualANZState {
    const newState: IAccrualANZState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors
            } as IRequestState
        }
    });

    return newState;
}

function clear(state: IAccrualANZState, propertiesToClear?: string[]): IAccrualANZState {

    if (!propertiesToClear) {
        const newState: IAccrualANZState = update(initialState, {});
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

const AccrualANZReducer: Reducer<IAccrualANZState> = (state: IAccrualANZState = initialState, action: AccrualANZAction) => {
    switch (action.type) {
        case ACTION_ACCRUALANZ_LOAD_BY_ID:
        case ACTION_ACCRUALANZ_LOAD_BY_TRIAL_ID:
            return loading(state, true);
        case ACTION_ACCRUALANZ_LOAD_SUCCESS:
            return loadSuccess(state, action.data, action.responseStatus);
        case ACTION_ACCRUALANZ_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_ACCRUALANZ_CLEAR:
            return clear(state, action.propertiesToClear);
    }

    return state;
}

export default AccrualANZReducer;